/* Cloudwear: AJAX "Pokaż więcej" na stronie kolekcji.
   Dokłada produkty z kolejnej strony paginacji bez przeładowania,
   podmienia licznik "Pokazano X z Y" i pasek postępu. */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.cw-loadmore__btn');
    if (!btn) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(btn.href)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('product-grid');
        var newGrid = doc.getElementById('product-grid');
        var wrapper = document.querySelector('.cw-loadmore');
        var newWrapper = doc.querySelector('.cw-loadmore');

        if (grid && newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (item) {
            grid.appendChild(item.cloneNode(true));
          });
        }
        if (wrapper) {
          if (newWrapper) {
            wrapper.replaceWith(newWrapper);
          } else {
            wrapper.remove();
          }
        }
        history.replaceState({}, '', btn.href);
      })
      .catch(function () {
        window.location.href = btn.href;
      });
  });
})();

/* 28.08: powrót z PDP do kolekcji — przywracamy dokładnie ten widok,
   który klientka zostawiła (doładowane strony + pozycja scrolla).
   Bez tego back po "Pokaż więcej" renderował samą stronę ?page=N od góry. */
(function () {
  var KEY = 'cw:coll:' + location.pathname;
  var onCollection = !!document.getElementById('product-grid');
  if (!onCollection) return;

  /* zapis stanu przy wyjściu w produkt (delegacja — karty też z AJAX) */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link) return;
    var grid = document.getElementById('product-grid');
    var wrapper = document.querySelector('.cw-loadmore');
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        html: grid.innerHTML,
        loadmore: wrapper ? wrapper.outerHTML : '',
        scroll: window.scrollY,
        href: location.href,
        t: Date.now(),
      }));
    } catch (e) { /* pełny storage — trudno */ }
  }, true);

  /* przywrócenie TYLKO przy nawigacji wstecz/naprzód */
  var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var isBack = nav ? nav.type === 'back_forward' : false;
  if (!isBack) return;
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!saved || !saved.html) return;
  var grid = document.getElementById('product-grid');
  grid.innerHTML = saved.html;
  var wrapper = document.querySelector('.cw-loadmore');
  if (wrapper) {
    if (saved.loadmore) {
      var tmp = document.createElement('div');
      tmp.innerHTML = saved.loadmore;
      wrapper.replaceWith(tmp.firstElementChild);
    } else {
      wrapper.remove();
    }
  }
  if (saved.href) history.replaceState({}, '', saved.href);
  window.requestAnimationFrame(function () {
    window.scrollTo(0, saved.scroll || 0);
    /* Safari/Chrome potrafią przywracać własny scroll po nas */
    window.setTimeout(function () { window.scrollTo(0, saved.scroll || 0); }, 120);
  });
})();
